export const TOKEN_KEY = 'loginToken'
export const REMEMBER_ME_KEY = 'rememberMeToken'
export const THEME_KEY = 'sevalla-ui-theme'
export const CHM_USER_KEY = 'chm-user'
export const CHM_PASSWORD_KEY = 'chm-password'
export const SELECTED_COMPANY_KEY = 'selected-company'
export const SIDEBAR_OPEN_KEY = 'sevalla-sidebar-open'
export const ONBOARDING_PROGRESS_KEY = 'sevalla-onboarding-progress'
export const STUDIO_GLOBAL_KEY = 'sevalla-studio-settings'
export const STUDIO_DATABASE_KEY_PREFIX = 'sevalla-studio-db-'
export const STUDIO_CONSOLE_KEY_PREFIX = 'sevalla-studio-console-'
export const STUDIO_REDIS_KEY_PREFIX = 'sevalla-studio-redis-'
export const DRIZZLE_KEY_PREFIX = 'drizzle-'
export const DRIZZLE_SQL_CONSOLE_KEY = 'drizzle-sql-console'
